import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Divider } from 'sarsaparilla';
import { PassTypeProps, PassInfoProps } from '../props';

import StartDateForm from './StartDateForm';
import HolderInfoForm from './HolderInfoForm';
import VehicleInfoForm from './VehicleInfoForm';
import AttendeeInfoForm from './AttendeeInfoForm';

const propTypes = {
  passType: PassTypeProps.isRequired,
  passInfo: PassInfoProps.isRequired,
  onChange: PropTypes.func.isRequired
};

export default class PassInfoForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      passInfo: this.props.passInfo
    };

    this.onStartDateChanged = this.onStartDateChanged.bind(this);
    this.onVehicleInfoChanged = this.onVehicleInfoChanged.bind(this);
    this.onHolderInfoChanged = this.onHolderInfoChanged.bind(this);
    this.onAttendeeInfoChanged = this.onAttendeeInfoChanged.bind(this);

    this.renderVisitorInfo = this.renderVisitorInfo.bind(this);
    this.renderVehicleInfo = this.renderVehicleInfo.bind(this);
  }

  componentDidMount() {
    this.props.onChange(this.props.passInfo, this.formIsValid());
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.passInfo !== this.props.passInfo) {
      this.setState((prevState) => ({ ...prevState, passInfo: nextProps.passInfo }));
    }
  }

  onStartDateChanged(startDate, startDateIsValid) {
    this.setState((prevState) => ({
      ...prevState,
      passInfo: { ...prevState.passInfo, start_date: startDate },
      startDateIsValid
    }), () => {
      this.props.onChange(this.state.passInfo, this.formIsValid());
    });
  }

  onVehicleInfoChanged(vehicleInfo, vehicleInfoIsValid) {
    this.setState((prevState) => ({
      ...prevState,
      passInfo: { ...prevState.passInfo, vehicle_info: vehicleInfo },
      vehicleInfoIsValid
    }), () => {
      this.props.onChange(this.state.passInfo, this.formIsValid());
    });
  }

  onHolderInfoChanged(holderInfo, holderInfoIsValid) {
    this.setState((prevState) => ({
      ...prevState,
      passInfo: { ...prevState.passInfo, holder_info: holderInfo },
      holderInfoIsValid
    }), () => {
      this.props.onChange(this.state.passInfo, this.formIsValid());
    });
  }

  onAttendeeInfoChanged(attendeeInfo, attendeeInfoIsValid) {
    this.setState((prevState) => ({
      ...prevState,
      passInfo: { ...prevState.passInfo, attendee_info: attendeeInfo },
      attendeeInfoIsValid
    }), () => {
      this.props.onChange(this.state.passInfo, this.formIsValid());
    });
  }

  formIsValid() {
    const { startDateIsValid, vehicleInfoIsValid, holderInfoIsValid, attendeeInfoIsValid } = this.state;
    const { passType: { features } } = this.props;
    let isValid = true;

    if (features.indexOf('start-date') !== -1) {
      isValid = isValid && startDateIsValid;
    }
    if (features.indexOf('vehicle-info') !== -1) {
      isValid = isValid && vehicleInfoIsValid;
    }
    if (features.indexOf('holder-info') !== -1) {
      isValid = isValid && holderInfoIsValid;
    }
    if (features.indexOf('attendee-info') !== -1) {
      isValid = isValid && attendeeInfoIsValid;
    }

    return isValid;
  }

  renderVisitorInfo(hasHolderInfo, hasAttendeeInfo) {
    const { passType } = this.props;
    const { passInfo } = this.state;

    if (!hasHolderInfo && !hasAttendeeInfo) {
      return null;
    }

    return (
      <div>
        <h4>Visitor Information</h4>
        {hasHolderInfo ? <HolderInfoForm
          holderInfo={passInfo.holder_info}
          passType={passType}
          onChange={this.onHolderInfoChanged} /> : null}
        {hasHolderInfo && hasAttendeeInfo ? <Divider /> : null}
        {hasAttendeeInfo ? <AttendeeInfoForm
          attendeeInfo={passInfo.attendee_info}
          passType={passType}
          onChange={this.onAttendeeInfoChanged} /> : null}
      </div>
    );
  }

  renderVehicleInfo() {
    const { passInfo, passType } = this.props;

    if (passType.features.indexOf('vehicle-info') === -1) {
      return null;
    }

    return (
      <div>
        <h4>Vehicle Information</h4>
        <VehicleInfoForm vehicleInfo={passInfo.vehicle_info} passType={passType} onChange={this.onVehicleInfoChanged} />
      </div>
    );
  }

  render() {
    const { passInfo, passType } = this.props;
    const hasHolderInfo = passType.features.indexOf('holder-info') !== -1;
    const hasAttendeeInfo = passType.features.indexOf('attendee-info') !== -1;
    const hasVehicleInfo = passType.features.indexOf('vehicle-info') !== -1;

    return (
      <div className="parkpass-pass-info-form">
        <StartDateForm startDate={passInfo.start_date} passType={passType} onChange={this.onStartDateChanged} />
        {this.renderVisitorInfo(hasHolderInfo, hasAttendeeInfo)}
        {this.renderVehicleInfo(hasVehicleInfo)}
      </div>
    );
  }
}

PassInfoForm.propTypes = propTypes;
